<template>
  <div class="tw:bg-gray-100 tw:py-[60px]">
    <ContainerLayout class="tw:flex tw:flex-col">
      <h1
        class="tw:pb-6 tw:md:pb-12 tw:text-[28px] tw:leading-[35px] tw:md:text-[44px] tw:md:leading-[55px] tw:mx-auto"
      >
        {{ $t('rc_case_studies_header') }}
      </h1>
      <div
        class="tw:mx-auto tw:flex tw:flex-col tw:w-full tw:lg:max-w-(--tw-breakpoint-landing) tw:md:max-w-[638px] tw:sm:max-w-[480px] tw:max-w-[300px]"
      >
        <RateConnectReviews
          v-scroll-animate="{ duration: '2s', delay: '0.3s' }"
          :withHeader="false"
          :withReadMore="true"
          :isLandingPage="false"
        />
      </div>
    </ContainerLayout>
  </div>
</template>
<script setup>
import RateConnectReviews from '@/components/productPage/rateConnect/RateConnectReviews.vue'
import ContainerLayout from '@/layouts/ContainerLayout.vue'
</script>
